import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../src/config";
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";
import Cookies from 'js-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import AdminGeralLayout from "../../components/AdminGeralLayout/AdminGeralLayout";

function EditarClienteMaster() {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    celular: "",
    novaSenha: "",
    valorMensalidade: "",
    dataVencimento: "",
    diasAvisoVencimento: 7,
    usaApiLembrete: false,
    appKey: "",
    authKey: "",
    tempoLembrete: "",
    atualizacaoAutomatica: false
  });

  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    carregarCliente();
  }, []);

  const carregarCliente = async () => {
    try {
      const token = Cookies.get("authToken");
      const response = await axios.get(`${API_BASE_URL}/admin-geral/clientes-master/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const cliente = response.data;
      setFormData({
        nome: cliente.nome || "",
        email: cliente.email || "",
        celular: cliente.celular || "",
        novaSenha: "",
        valorMensalidade: cliente.ValorMensalidade || "",
        dataVencimento: cliente.DataVencimento ? cliente.DataVencimento.split('T')[0] : "",
        diasAvisoVencimento: cliente.DiasAvisoVencimento || 7,
        usaApiLembrete: cliente.UsaApiLembrete || false,
        appKey: cliente.AppKey || "",
        authKey: cliente.AuthKey || "",
        tempoLembrete: cliente.TempoLembrete || "",
        atualizacaoAutomatica: cliente.AtualizacaoAutomatica || false
      });

      setLoading(false);
    } catch (err) {
      console.error(err);
      setErro("Erro ao carregar cliente.");
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro("");
    setSucesso("");

    try {
      const token = Cookies.get("authToken");
      
      const payload = {
        nome: formData.nome,
        email: formData.email,
        celular: formData.celular,
        novaSenha: formData.novaSenha || null,
        valorMensalidade: parseFloat(formData.valorMensalidade) || 0,
        dataVencimento: formData.dataVencimento || null,
        diasAvisoVencimento: parseInt(formData.diasAvisoVencimento) || 7,
        usaApiLembrete: formData.usaApiLembrete,
        appKey: formData.appKey || null,
        authKey: formData.authKey || null,
        tempoLembrete: formData.tempoLembrete ? parseInt(formData.tempoLembrete) : null,
        atualizacaoAutomatica: formData.atualizacaoAutomatica
      };

      await axios.put(`${API_BASE_URL}/admin-geral/clientes-master/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSucesso("Cliente Master atualizado com sucesso!");
      setTimeout(() => {
        navigate("/admin-geral/clientes-master");
      }, 2000);

    } catch (err) {
      console.error(err);
      if (err.response && err.response.data && err.response.data.message) {
        setErro(err.response.data.message);
      } else {
        setErro("Erro ao atualizar cliente.");
      }
    }
  };

  if (loading) {
    return (
      <Container className="mt-5">
        <p>Carregando...</p>
      </Container>
    );
  }

  return (
    <AdminGeralLayout activeKeyProp="clientes-master">
      <div className="mb-4">
        <h1>Editar Cliente Master</h1>
        <p className="text-muted">Edite as informações do cliente master ID: {id}.</p>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <Container fluid className="p-0">
          {erro && <Alert variant="danger" onClose={() => setErro("")} dismissible>{erro}</Alert>}
          {sucesso && <Alert variant="success">{sucesso}</Alert>}

        <Card className="shadow-sm" style={{width: "95%"}}>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nome *</Form.Label>
                      <Form.Control
                        type="text"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email *</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Celular *</Form.Label>
                      <Form.Control
                        type="text"
                        name="celular"
                        value={formData.celular}
                        onChange={handleChange}
                        placeholder="Ex: 11999999999"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Nova Senha (deixe em branco para não alterar)</Form.Label>
                      <Form.Control
                        type="password"
                        name="novaSenha"
                        value={formData.novaSenha}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Valor Mensalidade (R$)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.01"
                        name="valorMensalidade"
                        value={formData.valorMensalidade}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Data de Vencimento</Form.Label>
                      <Form.Control
                        type="date"
                        name="dataVencimento"
                        value={formData.dataVencimento}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group className="mb-3">
                      <Form.Label>Dias Aviso Vencimento</Form.Label>
                      <Form.Control
                        type="number"
                        name="diasAvisoVencimento"
                        value={formData.diasAvisoVencimento}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <hr />

                <h5>Configurações de WhatsApp</h5>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="usaApiLembrete"
                    label="Usa API de Lembrete"
                    checked={formData.usaApiLembrete}
                    onChange={handleChange}
                  />
                </Form.Group>

                {formData.usaApiLembrete && (
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>App Key</Form.Label>
                        <Form.Control
                          type="text"
                          name="appKey"
                          value={formData.appKey}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Auth Key</Form.Label>
                        <Form.Control
                          type="text"
                          name="authKey"
                          value={formData.authKey}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Tempo Lembrete (minutos)</Form.Label>
                        <Form.Control
                          type="number"
                          name="tempoLembrete"
                          value={formData.tempoLembrete}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="atualizacaoAutomatica"
                    label="Atualização Automática"
                    checked={formData.atualizacaoAutomatica}
                    onChange={handleChange}
                  />
                </Form.Group>

                <div className="d-flex justify-content-end">
                  <Button variant="secondary" className="me-2" onClick={() => navigate("/admin-geral/clientes-master")}>
                    Cancelar
                  </Button>
                  <Button variant="primary" type="submit">
                    Salvar Alterações
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Container>
      )}
    </AdminGeralLayout>
  );
}

export default EditarClienteMaster;
